import { FieldShell } from './FieldShell';
import { FieldSelect } from './FieldSelect';
import { useDomFieldName, useDomFieldId } from './_useFieldName';
import { FIELD_AUTOCOMPLETE_OFF } from './_fieldDefaults';

const BLOCK = 'LStudio__app_field';

/*
    🔥 NÚMERO CON UNIDAD

    Un número y su unidad en un solo control: 500 g, 2.5 m, 30 %.
    Si pasás una sola unidad se muestra fija; si pasás varias, un
    select pegado a la derecha.

    ⚠️ Mismo criterio que FieldCurrency: `maxDigits` corta la parte
       entera. El atributo `max` del input NO alcanza, porque el
       navegador deja tipear igual y solo marca el campo como inválido
       al enviar.
*/

export const FieldNumberUnit = ({
    id, name, label, hint, error,
    value = '', unit = '', onChange, onChangeUnit,
    units = null, min = null, max = null, step = 'any',
    maxDigits = 9,
    placeholder = '0',
    isRequired = false, isDisabled = false,
    span = 1, ...rest
}) => {

    const onHandleChange = (event) => {

        const RAW = event.target.value;

        if (maxDigits) {
            const INTEGER = String(RAW).split('.')[0].replace(/\D/g, '');
            if (INTEGER.length > maxDigits) return;
        }

        onChange?.(event);
    };

    const DOM_NAME = useDomFieldName();

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} hint={hint} error={error}
            isRequired={isRequired} isDisabled={isDisabled} span={span} >

            <div className={`${BLOCK}__unit`}>

                <input id={DOM_ID} data-field={name ?? id} name={DOM_NAME} type="number"
                    className={`${BLOCK}__input ${BLOCK}__unit_input`}
                    value={value} onChange={onHandleChange} placeholder={placeholder}
                    min={min ?? undefined} max={max ?? undefined} step={step}
                    required={isRequired} disabled={isDisabled}
                    autoComplete={FIELD_AUTOCOMPLETE_OFF}
                    aria-invalid={!!error}
                    {...rest} />

                {
                    units
                        ? (
                            <div className={`${BLOCK}__unit_select`}>
                                <FieldSelect isBare value={unit} options={units}
                                    onChange={onChangeUnit} isDisabled={isDisabled} isSearchable={false} />
                            </div>
                        )
                        : <span className={`${BLOCK}__unit_fixed`}>{unit}</span>
                }

            </div>

        </FieldShell>
    );
};
